export default "__VITE_ASSET__EC7Hjz6A__"